import axios from 'axios';

import { ComparableRentalsDto, PriceTrendDto, RentEstimateDto } from '../dtos/property-market-insights.dto.interface';

class PropertyMarketInsightsService {
  async getPriceTrend(propertyId: string): Promise<PriceTrendDto> {
    const response = await axios.get<PriceTrendDto>(`property/${propertyId}/market-insights/price-trend`);

    return response.data;
  }

  async getComparableRentals(propertyId: string): Promise<ComparableRentalsDto> {
    const response = await axios.get<ComparableRentalsDto>(`property/${propertyId}/market-insights/comparable-rentals`);

    return response.data;
  }

  async getRentEstimate(propertyId: string): Promise<RentEstimateDto> {
    const response = await axios.get<RentEstimateDto>(`property/${propertyId}/market-insights/rent-estimate`);

    return response.data;
  }
}

export default new PropertyMarketInsightsService();
